import type { NavigationGuard } from 'vue-router'
import { useVisitorsStore } from '@/shared/store'
import { getDateWithoutTime } from '@/shared/utils'
import { PurchaseFlowRoutes } from '@/shared/types/router.types'

export const quoteGuard: NavigationGuard = (to) => {
  const visitorsStore = useVisitorsStore()
  const visitDates = visitorsStore.getVisitDates

  if (!visitDates?.startDate) {
    return true
  }

  const nowDate = getDateWithoutTime(new Date()).getTime()
  const startDate = getDateWithoutTime(visitDates.startDate).getTime()

  if (nowDate > startDate) {
    return {
      name: PurchaseFlowRoutes.TRAVEL_DATE,
      query: to.query,
    }
  }

  return true
}
